import React, { useContext, useEffect, useState, useRef } from 'react';
import axios from "axios";
import { Link, useQueryParams } from 'raviger';
import { Button, Card, Col, Collapse, Form, FormControl, InputGroup, OverlayTrigger, Pagination, Row, Tooltip } from 'react-bootstrap';
import { Typeahead, Menu, MenuItem } from 'react-bootstrap-typeahead';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckSquare,
  faInfoCircle,
  faVial,
  faSyringe,
  faSoap,
  faEye,
  faWater,
  faWifi,
  faHeart,
  faPrescription,
  faCircle,
} from '@fortawesome/free-solid-svg-icons';
import {
  faDotCircle
} from '@fortawesome/free-regular-svg-icons';
import { faPipe } from '@fortawesome/pro-thin-svg-icons';
import { faChevronDoubleDown, faChevronDoubleUp, faChevronDown,
  faRectangle,
  faSquareExclamation,
  faScalpelLineDashed,
  faSquareX,
  faEyeDropper,
  faFlashlight,
  faPeriod,
  faMobileScreenButton,
  faPrescriptionBottlePill,
  faSquareEllipsis,
  faUserDoctorMessage} from '@fortawesome/pro-solid-svg-icons';
import {
  faRectangleVertical,
} from '@fortawesome/sharp-solid-svg-icons';
import { faBandage, faRing, faSpiral } from '@fortawesome/pro-regular-svg-icons';
import Select from 'react-select';
import Moment from 'react-moment';
import moment from 'moment';
import { DateRangePicker } from '../components/Form';
import { useMark } from '../hooks';
import Header from '../components/Header';
import { ITEMS_PER_PAGE } from '../constants';
import Paginator from '../components/Paginator';
import { SystemErrorContext } from '../components/SystemError';
import { AuthContext } from "../accounts/AccountsReducer";
import TreatmentCard from "./components/TreatmentCard";
import DiagnosticCard from './components/DiagnosticCard';
import ProcedureCard from './components/ProcedureCard';
import { capitalize } from '../utils/formatString';

const ToggleButton = ({ isOpen, onClick }) => (
  <span
    style={{zIndex:"11", marginLeft:"-25px"}}
    className="toggle-button"
    onClick={onClick}
    onMouseDown={(e) => {
      // Prevent input from losing focus.
      e.preventDefault();
    }}>
    {<>
      <FontAwesomeIcon icon={faPipe} style={{zIndex:"9999", height:"20px", marginLeft:"1px"}} transform={'grow-1 down-8 left-12'} color="#cccccc" size="sm" />
      <FontAwesomeIcon icon={faChevronDown} style={{zIndex:"9999", WebkitTextStroke: '0.5px', fontWeight:"bold"}} transform={'down-8 left-4'} color="#cccccc" size="sm" />
    </>}
  </span>
);

function VetRequestSearch({ incident, organization }) {

  const { state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);

  // Identify any query param data.
  const [queryParams] = useQueryParams();
  const {
    search = '',
    tab = 'vet_requests',
  } = queryParams;

  const priorityText = {urgent:'Urgent (Red)', when_available:'When Available (Yellow)'};
  const labelLookup = {vet_requests:'Veterinary Requests', treatments:'Treatments', diagnostics:'Diagnostics', procedures:'Procedures'};

  const priorityChoices = [
    { value: 'urgent', label: 'Urgent (Red)' },
    { value: 'when_available', label: 'When Available (Yellow)' },
  ];

  const statusChoices = [
    { value: 'Open', label: 'Open' },
    { value: 'Closed', label: 'Closed' },
    // { value: 'Canceled', label: 'Canceled' },
  ];

  const treatmentStatusChoices = [
    { value: 'Pending', label: 'Pending' },
    { value: 'Scheduled', label: 'Scheduled' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Not Administered', label: 'Not Administered' },
  ];

  const orderStatusChoices = [
    { value: 'Pending', label: 'Pending' },
    { value: 'Completed', label: 'Completed' },
  ];

  const tooltipDict = {
    'vet_requests': 'id, animal id, animal name, concern, and complaint name',
    'treatments': 'id, treatment name, animal name, assignee first name, and assignee last name',
    'diagnostics': 'id, diagnostic name, and animal name',
    'procedures': 'id, procedure name, animal name, performer first name, and performer last name'
  }

  const [data, setData] = useState({vet_requests:[], treatments:[], diagnostics:[], procedures:[], isFetching:true});
  const [shelters, setShelters] = useState({options:[], isFetching:false});
  const [triggerRefresh, setTriggerRefresh] = useState(false);
  const [speciesChoices, setSpeciesChoices] = useState([]);
  const [treatmentChoices, setTreatmentChoices] = useState([]);
  const [diagnosticChoices, setDiagnosticChoices] = useState([]);
  const [procedureChoices, setProcedureChoices] = useState([]);
  const [presentingComplaintChoices, setPresentingComplaintChoices] = useState([]);
  const [openers, setOpeners] = useState([]);
  const [assignees, setAssignees] = useState([]);
  const [searchTerm, setSearchTerm] = useState(search);
  const [showFilters, setShowFilters] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [treatmentIsDisabled, setTreatmentIsDisabled] = useState(true);
  const [diagnosticIsDisabled, setDiagnosticIsDisabled] = useState(true);
  const [procedureIsDisabled, setProcedureIsDisabled] = useState(true);
  const [vetObject, setVetObject] = useState(tab);
  const tempSearchTerm = useRef(null);
  const treatmentRef = useRef(null);
  const diagnosticRef = useRef(null);
  const procedureRef = useRef(null);
  const speciesRef = useRef(null);
  const treatmentSpeciesRef = useRef(null);
  const diagnosticSpeciesRef = useRef(null);
  const procedureSpeciesRef = useRef(null);
  const statusRef = useRef(null);
  const treatmentStatusRef = useRef(null);
  const diagnosticStatusRef = useRef(null);
  const procedureStatusRef = useRef(null);
  const administratorRef = useRef(null);
  const complaintsRef = useRef(null);
  const priorityRef = useRef(null);
  const openerRef = useRef(null);
  const performerRef = useRef(null);
  const openStartRef = useRef(null);
  const openEndRef = useRef(null);
  const scheduledStartRef = useRef(null);
  const scheduledEndRef = useRef(null);
  const administeredStartRef = useRef(null);
  const administeredEndRef = useRef(null);
  const diagnosticOrderedStartRef = useRef(null);
  const diagnosticOrderedEndRef = useRef(null);
  const diagnosticCompleteStartRef = useRef(null);
  const diagnosticCompleteEndRef = useRef(null);
  const procedureOrderedStartRef = useRef(null);
  const procedureOrderedEndRef = useRef(null);
  const procedureCompleteStartRef = useRef(null);
  const procedureCompleteEndRef = useRef(null);
  const controlledRef = useRef(null);
  const shelterRef = useRef(null);
  const treatmentShelterRef = useRef(null);
  const diagnosticShelterRef = useRef(null);
  const procedureShelterRef = useRef(null);
  const [treatments, setTreatments] = useState([]);
  const [diagnostics, setDiagnostics] = useState([]);
  const [procedures, setProcedures] = useState([]);
  const [options, setOptions] = useState({species:[], status:[], priority:[], open_start:null, open_end:null, opener:null, shelter:[], complaints:[]});
  const [treatmentOptions, setTreatmentOptions] = useState({species:[], status:[], treatment:'', scheduled_start:null, scheduled_end:null, administered_start:null, administered_end:null, assignee:null, shelter:[], controlled:null});
  const [diagnosticOptions, setDiagnosticOptions] = useState({species:[], status:[], diagnostic:'', scheduled_start:null, scheduled_end:null, completed_start:null, completed_end:null, performer:null, shelter:[]});
  const [procedureOptions, setProcedureOptions] = useState({species:[], status:[], procedure:'', scheduled_start:null, scheduled_end:null, completed_start:null, completed_end:null, performer:null, shelter:[]});
  const [page, setPage] = useState(1);
  const [numPages, setNumPages] = useState(1);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const { markInstances } = useMark();
  const [tooltip, setTooltip] = useState(tooltipDict['vet_requests']);

  // Update searchTerm when field input changes.
  const handleChange = event => {
    tempSearchTerm.current.value = event.target.value;
  };

  // Use searchTerm to filter vet_requests.
  const handleSubmit = async event => {
    event.preventDefault();
    setSearchTerm(tempSearchTerm.current.value);
    setPage(1);
  };

  const handleShowFilters = () => {
    setShowFilters(!showFilters);
  };

  // Parses the Date Range object
  function parseDateRange(dateRange) {
    if (dateRange.length > 1) {
      dateRange = dateRange.toString().split(',');
      setStartDate(moment(dateRange[0]).format('YYYY-MM-DD'))
      setEndDate(moment(dateRange[1]).format('YYYY-MM-DD'));
    }
  }

  function setFocus(pageNum) {
    if (pageNum !== page) {
      tempSearchTerm.current.focus();
    }
  };

   function updateTooltip(search_tab) {
    setTooltip(tooltipDict[search_tab]);
  }

  const handleClear = () => {
    if (vetObject === 'vet_requests') {
      speciesRef.current.clear();
      statusRef.current.clear();
      priorityRef.current.clear();
      if (openStartRef.current) {
        openStartRef.current.flatpickr.clear();
      }
      if (openEndRef.current) {
        openEndRef.current.flatpickr.clear();
      }
      openerRef.current.clearValue();
      shelterRef.current.clear();
      setOptions({species:[], status:[], priority:[], open_start:null, open_end:null, assignee:null, shelter:[], complaints:[]});
      // setVetRequests(data.vet_requests);
    }
    else if (vetObject === 'treatments') {
      treatmentRef.current.clearValue();
      treatmentSpeciesRef.current.clear();
      treatmentStatusRef.current.clear();
      treatmentShelterRef.current.clear();
      controlledRef.current.clearValue();
      administratorRef.current.clearValue();
      if (scheduledStartRef.current) {
        scheduledStartRef.current.flatpickr.clear();
      }
      if (scheduledEndRef.current) {
        scheduledEndRef.current.flatpickr.clear();
      }
      if (administeredStartRef.current) {
        administeredStartRef.current.flatpickr.clear();
      }
      if (administeredEndRef.current) {
        administeredEndRef.current.flatpickr.clear();
      }
      setTreatmentOptions({species:[], status:[], treatment:null, scheduled_start:null, scheduled_end:null, administered_start:null, administered_end:null, assignee:null, shelter:[], controlled:null});
      // setTreatments(data.treatments);
    }
    else if (vetObject === 'diagnostics') {
      diagnosticRef.current.clearValue();
      diagnosticSpeciesRef.current.clear();
      diagnosticStatusRef.current.clear();
      diagnosticShelterRef.current.clear();
      if (diagnosticOrderedStartRef.current) {
        diagnosticOrderedStartRef.current.flatpickr.clear();
      }
      if (diagnosticOrderedEndRef.current) {
        diagnosticOrderedEndRef.current.flatpickr.clear();
      }
      if (diagnosticCompleteStartRef.current) {
        diagnosticCompleteStartRef.current.flatpickr.clear();
      }
      if (diagnosticCompleteEndRef.current) {
        diagnosticCompleteEndRef.current.flatpickr.clear();
      }
      setDiagnosticOptions({species:[], status:[], diagnostic:null, scheduled_start:null, scheduled_end:null, complete_start:null, complete_end:null, performer:null, shelter:[]});
      // setDiagnostics(data.diagnostics);
    }
    else if (vetObject === 'procedures') {
      procedureRef.current.clearValue();
      procedureSpeciesRef.current.clear();
      procedureStatusRef.current.clear();
      procedureShelterRef.current.clear();
      if (procedureOrderedStartRef.current) {
        procedureOrderedStartRef.current.flatpickr.clear();
      }
      if (procedureOrderedEndRef.current) {
        procedureOrderedEndRef.current.flatpickr.clear();
      }
      if (procedureCompleteStartRef.current) {
        procedureCompleteStartRef.current.flatpickr.clear();
      }
      if (procedureCompleteEndRef.current) {
        procedureCompleteEndRef.current.flatpickr.clear();
      }
      setProcedureOptions({species:[], status:[], procedure:null, scheduled_start:null, scheduled_end:null, completed_start:null, completed_end:null, performer:null, shelter:[]});
      // setProcedures(data.procedures);
    }
    setTriggerRefresh(!triggerRefresh);
  };

  const customStyles = {
    // For the select it self, not the options of the select
    control: (styles, { isDisabled}) => {
      return {
        ...styles,
        color: '#FFF',
        cursor: isDisabled ? 'not-allowed' : 'default',
        backgroundColor: isDisabled ? '#DFDDDD' : 'white',
        height: 35,
        minHeight: 35,
        marginBottom: "10px"
      }
    },
    option: provided => ({
      ...provided,
      color: 'black'
    }),
    menu: provided => ({ ...provided, zIndex: 9999 })
  };

  const typeCustomStyles = {
    // For the select it self, not the options of the select
    control: (styles, { isDisabled}) => {
      return {
        ...styles,
        color: '#FFF',
        cursor: isDisabled ? 'not-allowed' : 'default',
        backgroundColor: isDisabled ? '#DFDDDD' : 'white',
        height: 37,
        minHeight: 37,
        marginBottom: "10px"
      }
    },
    option: provided => ({
      ...provided,
      color: 'black'
    }),
    menu: provided => ({ ...provided, zIndex: 9999 })
  };

  // Hook for initializing advanced filter data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();
    tempSearchTerm.current.focus();

    const fetchSpecies = () => {
      setSpeciesChoices([]);
      // Fetch Species data.
      axios.get('/animals/api/species/', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let species_options = [];
          response.data.forEach(result => {
            // Build species option list.
            species_options.push({value: result.name, label: result.name});
          });
          setSpeciesChoices(species_options);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShelters({options: []});
          setShowSystemError(true);
        }
      });
    };
    // Only fetch species if needed.
    if (speciesChoices.length === 0) {
      fetchSpecies();
    }

    const fetchPresentingComplaints = async () => {
      // Fetch assignee data.
      await axios.get('/vet/api/complaints/', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let options = [];
          response.data.forEach(function(complaint) {
            options.push({value: complaint.id, label: complaint.name})
          });
          setPresentingComplaintChoices(options);
        }
      })
      .catch(error => {
        setShowSystemError(true);
      });
    };
    // Only fetch complaints if needed.
    if (vetObject === 'vet_requests' && presentingComplaintChoices.length === 0) {
      fetchPresentingComplaints();
    }

    const fetchTreatments = () => {
      setTreatmentChoices([]);
      // Fetch Treatment data.
      axios.get('/vet/api/treatment/', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let treatment_options = [];
          response.data.forEach(result => {
            // Build treatment option list.
            treatment_options.push({value: result.id, label: result.description});
          });
          setTreatmentChoices(treatment_options);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setTreatmentChoices([]);
          setShowSystemError(true);
        }
      });
    };
    // Only fetch treatments if needed.
    if (vetObject === 'treatments' && treatmentChoices.length === 0) {
      fetchTreatments();
    }

    const fetchDiagnostics = () => {
      setDiagnosticChoices([]);
      // Fetch Treatment data.
      axios.get('/vet/api/diagnostics/', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let diagnostic_options = [];
          response.data.forEach(result => {
            // Build diagnostic option list.
            diagnostic_options.push({value: result.id, label: result.name});
          });
          setDiagnosticChoices(diagnostic_options);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setDiagnosticChoices([]);
          setShowSystemError(true);
        }
      });
    };
    // Only fetch diagnostics if needed.
    if (vetObject === 'diagnostics' && diagnosticChoices.length === 0) {
      fetchDiagnostics();
    }

    const fetchProcedures = () => {
      setProcedureChoices([]);
      // Fetch Procedure data.
      axios.get('/vet/api/procedures/', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let procedure_options = [];
          response.data.forEach(result => {
            // Build procedure option list.
            procedure_options.push({value: result.id, label: result.name});
          });
          setProcedureChoices(procedure_options);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setProcedureChoices([]);
          setShowSystemError(true);
        }
      });
    };
    // Only fetch procedures if needed.
    if (vetObject === 'procedures' && procedureChoices.length === 0) {
      fetchProcedures();
    }

    const fetchShelters = () => {
      setShelters({options: [], isFetching: true});
      // Fetch Shelter data.
      axios.get('/shelter/api/shelter/?incident=' + incident + '&organization=' + organization, {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let shelter_options = [];
          response.data.forEach(shelter => {
            // Build shelter option list.
            shelter_options.push({value: shelter.id, label: shelter.name});
          });
          shelter_options.push({value: 0, label: 'Field'});
          setShelters({options: shelter_options, isFetching:false});
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShelters({options: [], isFetching: false});
          setShowSystemError(true);
        }
      });
    };
    // Only fetch shelters if needed.
    if (shelters.options.length === 0) {
      fetchShelters();
    }

    const fetchOpeners = async () => {
      // Fetch assignee data.
      await axios.get('/accounts/api/user/?vet_openers=true&incident=' + state.incident.id, {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let options = [];
          response.data.forEach(function(person) {
            options.unshift({value: person.id, label: person.first_name + ' ' + person.last_name})
          });
          setOpeners(options);
        }
      })
      .catch(error => {
        setShowSystemError(true);
      });
    };
    // Only fetch people if needed.
    if (openers.length === 0) {
      fetchOpeners();
    }

    const fetchAssignees = async () => {
      // Fetch assignee data.
      await axios.get('/accounts/api/user/?vet_techs=true&incident=' + state.incident.id + '&organization=' + state.organization.id, {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let options = [];
          response.data.forEach(function(person) {
            options.unshift({value: person.id, label: person.first_name + ' ' + person.last_name})
          });
          setAssignees(options);
        }
      })
      .catch(error => {
        setShowSystemError(true);
      });
    };
    // Only fetch people if needed.
    if (vetObject !== 'vet_requests' && assignees.length === 0) {
      fetchAssignees();
    }

    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [incident, organization, vetObject]);

  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    setNumPages(0);
    setData(prevState => ({ ...prevState, "isFetching":true }));

    const fetchVetRequests = async () => {
      // Fetch VetRequest data.
      await axios.get('/vet/api/vetrequest/?page=' + page + '&search=' + searchTerm +'&incident=' + state.incident.id, {
        cancelToken: source.token,
        params: {
          status: options.status,
          species: options.species,
          priority: options.priority,
          complaints: options.complaints,
          open_start: options.open_start,
          open_end: options.open_end,
          assignee: options.opener,
          shelter: options.shelter,
        },
      })
      .then(response => {
        if (!unmounted) {
          setNumPages(Math.ceil(response.data.count / ITEMS_PER_PAGE));
          setData(prevState => ({ ...prevState, "vet_requests":response.data.results, isFetching:false }));

          // highlight search terms
          markInstances(searchTerm);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setData({vet_requests: [], isFetching: false});
          setShowSystemError(true);
        }
      });
    };
    if (vetObject === 'vet_requests') {
      fetchVetRequests();
    }

    const fetchTreatmentRequests = async () => {
      // Fetch TreatmentRequest data.
      await axios.get('/vet/api/treatmentrequest/?page=' + page + '&search=' + searchTerm +'&incident=' + state.incident.id, {
        cancelToken: source.token,
        params: {
          status: treatmentOptions.status,
          species: treatmentOptions.species,
          treatment: treatmentOptions.treatment,
          scheduled_start: treatmentOptions.scheduled_start,
          scheduled_end: treatmentOptions.scheduled_end,
          administered_start: treatmentOptions.administered_start,
          administered_end: treatmentOptions.administered_end,
          assignee: treatmentOptions.assignee,
          shelter: treatmentOptions.shelter,
          // not_administered: treatmentOptions.not_administered,
          controlled: treatmentOptions.controlled,
        },
      })
      .then(response => {
        if (!unmounted) {
          setNumPages(Math.ceil(response.data.count / ITEMS_PER_PAGE));
          setData(prevState => ({ ...prevState, "treatments":response.data.results, isFetching:false }));

          // highlight search terms
          markInstances(searchTerm);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShowSystemError(true);
        }
      });
    };

    if (vetObject === 'treatments') {
      fetchTreatmentRequests();
    }

    const fetchDiagnosticResult = async () => {
      // Fetch diagnostic result data.
      await axios.get('/vet/api/diagnosticresults/?page=' + page + '&search=' + searchTerm +'&incident=' + state.incident.id, {
        cancelToken: source.token,
        params: {
          status: diagnosticOptions.status,
          species: diagnosticOptions.species,
          diagnostic: diagnosticOptions.diagnostic,
          scheduled_start: diagnosticOptions.scheduled_start,
          scheduled_end: diagnosticOptions.scheduled_end,
          completed_start: diagnosticOptions.completed_start,
          completed_end: diagnosticOptions.completed_end,
          performer: diagnosticOptions.performer,
          shelter: diagnosticOptions.shelter,
        },
      })
      .then(response => {
        if (!unmounted) {
          setNumPages(Math.ceil(response.data.count / ITEMS_PER_PAGE));
          setData(prevState => ({ ...prevState, "diagnostics":response.data.results, isFetching:false }));

          // highlight search terms
          markInstances(searchTerm);
        }
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          console.log('Request canceled gracefully:', error.message);
        } else if (error.response)
        {
          setShowSystemError(true);
        }
      });
    };

    if (vetObject === 'diagnostics') {
      fetchDiagnosticResult();
    }

    const fetchProcedureResult = async () => {
      // Fetch procedure result data.
      await axios.get('/vet/api/procedureresults/?page=' + page + '&search=' + searchTerm +'&incident=' + state.incident.id, {
        cancelToken: source.token,
        params: {
          status: procedureOptions.status,
          species: procedureOptions.species,
          procedure: procedureOptions.procedure,
          scheduled_start: procedureOptions.scheduled_start,
          scheduled_end: procedureOptions.scheduled_end,
          completed_start: procedureOptions.completed_start,
          completed_end: procedureOptions.completed_end,
          performer: procedureOptions.performer,
          shelter: procedureOptions.shelter,
        },
      })
      .then(response => {
        if (!unmounted) {
          setNumPages(Math.ceil(response.data.count / ITEMS_PER_PAGE));
          setData(prevState => ({ ...prevState, "procedures":response.data.results, isFetching:false }));

          // highlight search terms
          markInstances(searchTerm);
        }
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          console.log('Request canceled gracefully:', error.message);
        } else if (error.response)
        {
          setShowSystemError(true);
        }
      });
    };

    if (vetObject === 'procedures') {
      fetchProcedureResult();
    }

    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [searchTerm, incident, triggerRefresh, vetObject, page]);

  // Hook handling option changes.
  useEffect(() => {
    const handleDisabled = () => {
      setIsDisabled(!(options.species || options.status || options.priority || options.open_start || options.open_end || options.opener || options.shelter || options.complaints));
      setTreatmentIsDisabled(!(treatmentOptions.species || treatmentOptions.status || treatmentOptions.treatment || treatmentOptions.scheduled_start || treatmentOptions.scheduled_end || treatmentOptions.administered_start || treatmentOptions.administered_end || treatmentOptions.assignee || treatmentOptions.shelter));
      setDiagnosticIsDisabled(!(diagnosticOptions.species || diagnosticOptions.status || diagnosticOptions.diagnostic || diagnosticOptions.ordered_start || diagnosticOptions.complete_start || diagnosticOptions.ordered_end || diagnosticOptions.complete_end || diagnosticOptions.performer || diagnosticOptions.shelter));
      setProcedureIsDisabled(!(procedureOptions.species || procedureOptions.status || procedureOptions.procedure || procedureOptions.ordered_start || procedureOptions.complete_start || procedureOptions.ordered_end || procedureOptions.complete_end || procedureOptions.performer || procedureOptions.shelter));
    };

    handleDisabled();
  }, [options, treatmentOptions, diagnosticOptions, procedureOptions]);

  return (
    <div className="ms-2 me-2">
      <Header>Search Veterinary Tasks</Header>
      <Form onSubmit={handleSubmit}>
        <InputGroup className="mb-2">
          <FormControl
            type="text"
            placeholder="Search"
            name="searchTerm"
            onChange={handleChange}
            ref={tempSearchTerm}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSubmit(e);
              }
            }}
            style={{height:"38px"}}
          />
          <Button variant="outline-light" type="submit" style={{height:"38px", borderRadius:"0 5px 5px 0", color:"white"}}>Search
            <OverlayTrigger
              key={"search-information"}
              placement="right"
              overlay={
                <Tooltip id={`tooltip-search-information`}>
                  Searchable fields: {tooltip}.
                </Tooltip>
              }
            >
              <FontAwesomeIcon icon={faInfoCircle} className="ms-1 fa-move-up" size="sm" inverse />
            </OverlayTrigger>
          </Button>
          <Button variant="outline-light" className="ms-1 rounded" onClick={handleShowFilters} style={{height:"38px", color:"white"}}>Advanced {showFilters ? <FontAwesomeIcon icon={faChevronDoubleUp} className="fa-move-up" size="sm" /> : <FontAwesomeIcon icon={faChevronDoubleDown} className="fa-move-up" size="sm" />}</Button>
          <Col className="ps-2" style={{maxWidth:"220px"}}>
            <Select
              id="typeDropdown"
              name="vetType"
              type="text"
              options={[{value:'vet_requests', label:'Veterinary Requests'}, {value:'treatments', label:'Treatments'}, {value:'diagnostics', label:'Diagnostics'}, {value:'procedures', label:'Procedures'}]}
              styles={typeCustomStyles}
              isClearable={false}
              onChange={(instance) => {
                setVetObject(instance.value);
                updateTooltip(instance.value);
                handleClear();
              }}
              defaultValue={{value:tab, label:labelLookup[tab]}}
            />
          </Col>
        </InputGroup>
        {vetObject === 'vet_requests' ? <Collapse in={showFilters} className="mb-3">
          <div>
          <Card className="border rounded d-flex" style={{width:"100%"}}>
            <Card.Body style={{marginBottom:"-16px"}}>
              <Row className="gx-2">
                <Col xs={"9"} style={{textTransform:"capitalize"}}>
                  <Typeahead
                    id="status"
                    name="status"
                    multiple
                    onChange={(values) => {
                      setOptions({...options, status: values.map(option => option.value)});
                    }}
                    ref={statusRef}
                    options={statusChoices}
                    placeholder="Filter by Status..."
                    className="status-typeahead mb-2 no-wrap-container w-100"
                    selected={statusChoices.filter(choice => options.status.includes(choice.value))}
                    inputProps={{ className: 'custom-typeahead-input' }}
                  >
                    {({ isMenuShown, toggleMenu }) => (
                      <ToggleButton isOpen={isMenuShown} onClick={(e) => toggleMenu()} />
                    )}
                  </Typeahead>
                  <Typeahead
                    id="priority"
                    name="priority"
                    multiple
                    onChange={(values) => {
                      setOptions({...options, priority: values.map(option => option.value)});
                    }}
                    ref={priorityRef}
                    options={priorityChoices}
                    placeholder="Filter by Priority..."
                    className="priority-typeahead mb-2 no-wrap-container w-100"
                    selected={priorityChoices.filter(choice => options.priority.includes(choice.value))}
                    inputProps={{ className: 'custom-typeahead-input' }}
                  >
                    {({ isMenuShown, toggleMenu }) => (
                      <ToggleButton isOpen={isMenuShown} onClick={(e) => toggleMenu()} />
                    )}
                  </Typeahead>
                  <Typeahead
                    id="complaints"
                    name="complaints"
                    multiple
                    onChange={(values) => {
                      setOptions({...options, complaints: values.map(option => option.value)});
                    }}
                    ref={complaintsRef}
                    options={presentingComplaintChoices}
                    placeholder="Filter by Presenting Complaints..."
                    className="complaints-typeahead mb-2 no-wrap-container w-100"
                    selected={presentingComplaintChoices.filter(choice => options.complaints.includes(choice.value))}
                    inputProps={{ className: 'custom-typeahead-input' }}
                  >
                    {({ isMenuShown, toggleMenu }) => (
                      <ToggleButton isOpen={isMenuShown} onClick={(e) => toggleMenu()} />
                    )}
                  </Typeahead>
                  <Typeahead
                    id="species"
                    name="species"
                    multiple
                    onChange={(values) => {
                      setOptions({...options, species: values.map(option => option.value)});
                    }}
                    ref={speciesRef}
                    options={speciesChoices}
                    placeholder="Filter by Patient Species..."
                    className="species-typeahead mb-2 no-wrap-container w-100"
                    selected={speciesChoices.filter(choice => options.species.includes(choice.value))}
                    inputProps={{ className: 'custom-typeahead-input' }}
                  >
                    {({ isMenuShown, toggleMenu }) => (
                      <ToggleButton isOpen={isMenuShown} onClick={(e) => toggleMenu()} />
                    )}
                  </Typeahead>
                  <Typeahead
                    id="shelter"
                    name="shelter"
                    multiple
                    onChange={(values) => {
                      setOptions({...options, shelter: values.map(option => option.value)});
                    }}
                    ref={shelterRef}
                    options={shelters.options}
                    placeholder="Filter by Patient Shelter..."
                    className="shelter-typeahead mb-2 no-wrap-container w-100"
                    selected={shelters.options.filter(choice => options.shelter.includes(choice.value))}
                    inputProps={{ className: 'custom-typeahead-input' }}
                  >
                    {({ isMenuShown, toggleMenu }) => (
                      <ToggleButton isOpen={isMenuShown} onClick={(e) => toggleMenu()} />
                    )}
                  </Typeahead>
                  <Select
                    id="assigneeDropdown"
                    name="assignee"
                    type="text"
                    placeholder="Select VR Opener"
                    options={openers}
                    styles={customStyles}
                    isClearable={true}
                    ref={openerRef}
                    onChange={(instance) => {
                      setOptions({...options, opener: instance ? instance.value : null});
                    }}
                    value={options.opener ? openers.filter(assignee => assignee.value === options.opener)[0] : null}
                  />
                </Col>
                <Col className="flex-grow-1" xs="3">
                  <Button className="btn btn-primary" style={{maxHeight:"35px", width:"100%"}} onClick={() => {tempSearchTerm.current.value !== searchTerm ? setSearchTerm(tempSearchTerm.current.value) : setTriggerRefresh(!triggerRefresh);}} disabled={isDisabled}>Apply</Button>
                  <Button variant="outline-light" style={{maxHeight:"35px", width:"100%", marginTop:"10px"}} onClick={handleClear}>Clear</Button>
                </Col>
                <Row className="gx-2 pe-0" style={{marginBottom:"10px"}}>
                  <Col>
                    <DateRangePicker
                      data-enable-time={false}
                      name={`open_start`}
                      id={`open_start`}
                      mode="single"
                      placeholder={"Filter by Scheduled Start Date"}
                      style={{height:"36px"}}
                      ref={openStartRef}
                      data-enable-time={false}
                      clearable="true"
                      value={options.open_start || null}
                      onChange={(dateRange) => {
                        setOptions({...options, open_start: dateRange.length ? dateRange[0] : null});
                      }}
                    />
                  </Col>
                  <Col className="pe-0">
                    <DateRangePicker
                      data-enable-time={false}
                      name={`open_end`}
                      id={`open_end`}
                      mode="single"
                      placeholder={"Filter by Scheduled End Date"}
                      style={{height:"36px"}}
                      ref={openEndRef}
                      data-enable-time={false}
                      clearable="true"
                      hour={23}
                      minute={59}
                      value={options.open_end || null}
                      onChange={(dateRange) => {
                        setOptions({...options, open_end: dateRange.length ? dateRange[0] : null});
                      }}
                    />
                  </Col>
                  <Col xs="3"/>
                </Row>
              </Row>
            </Card.Body>
          </Card>
          </div>
        </Collapse>
        : vetObject === 'treatments' ? <Collapse in={showFilters} className="mb-3">
        <div>
        <Card className="border rounded d-flex" style={{width:"100%"}}>
          <Card.Body style={{marginBottom:"-16px"}}>
            <Row className="gx-2">
              <Col xs={"9"} style={{textTransform:"capitalize"}}>
                <Select
                  id="treatmentDropdown"
                  name="treatment"
                  type="text"
                  placeholder="Select Treatment"
                  options={treatmentChoices}
                  styles={customStyles}
                  isClearable={true}
                  ref={treatmentRef}
                  onChange={(instance) => {
                    setTreatmentOptions({...treatmentOptions, treatment: instance ? instance.value : ''})
                  }}
                  value={treatmentOptions.treatment ? treatmentChoices.filter(treatment => treatment.id === treatmentOptions.treatment)[0] : null}
                />
                <Typeahead
                  id="status"
                  name="status"
                  multiple
                  onChange={(values) => {
                    setTreatmentOptions({...treatmentOptions, status: values.map(option => option.value)});
                  }}
                  ref={treatmentStatusRef}
                  options={treatmentStatusChoices}
                  placeholder="Filter by Status..."
                  className="status-typeahead mb-2 no-wrap-container w-100"
                  selected={treatmentStatusChoices.filter(choice => treatmentOptions.status.includes(choice.value))}
                  inputProps={{ className: 'custom-typeahead-input' }}
                >
                  {({ isMenuShown, toggleMenu }) => (
                    <ToggleButton isOpen={isMenuShown} onClick={(e) => toggleMenu()} />
                  )}
                </Typeahead>
                <Select
                  id="administratorDropdown"
                  name="administrator"
                  type="text"
                  placeholder="Select Administrator"
                  options={assignees}
                  styles={customStyles}
                  isClearable={true}
                  ref={administratorRef}
                  onChange={(instance) => {
                    setTreatmentOptions({...treatmentOptions, assignee: instance ? instance.value : null});
                  }}
                  value={treatmentOptions.assignee ? assignees.filter(assignee => assignee.value === treatmentOptions.assignee)[0] : null}
                />
                <Typeahead
                  id="species"
                  name="species"
                  multiple
                  onChange={(values) => {
                    setTreatmentOptions({...treatmentOptions, species: values.map(option => option.value)});
                  }}
                  ref={treatmentSpeciesRef}
                  options={speciesChoices}
                  placeholder="Filter by Patient Species..."
                  className="species-typeahead mb-2 no-wrap-container w-100"
                  selected={speciesChoices.filter(choice => treatmentOptions.species.includes(choice.value))}
                  inputProps={{ className: 'custom-typeahead-input' }}
                >
                  {({ isMenuShown, toggleMenu }) => (
                    <ToggleButton isOpen={isMenuShown} onClick={(e) => toggleMenu()} />
                  )}
                </Typeahead>
                <Typeahead
                  id="shelter"
                  name="shelter"
                  multiple
                  onChange={(values) => {
                    setTreatmentOptions({...treatmentOptions, shelter: values.map(option => option.value)});
                  }}
                  ref={treatmentShelterRef}
                  options={shelters.options}
                  placeholder="Filter by Patient Shelter..."
                  className="shelter-typeahead mb-2 no-wrap-container w-100"
                  selected={shelters.options.filter(choice => treatmentOptions.shelter.includes(choice.value))}
                  inputProps={{ className: 'custom-typeahead-input' }}
                >
                  {({ isMenuShown, toggleMenu }) => (
                    <ToggleButton isOpen={isMenuShown} onClick={(e) => toggleMenu()} />
                  )}
                </Typeahead>
              </Col>
              <Col className="flex-grow-1" xs="3">
                <Select
                  id="controlled"
                  name="controlled"
                  type="text"
                  placeholder="Filter by Controlled..."
                  options={[{value:true, label:"True"},{value:false, label:'False'}]}
                  styles={customStyles}
                  isClearable={true}
                  ref={controlledRef}
                  onChange={(instance) => {
                    setTreatmentOptions({...treatmentOptions, controlled : instance ? instance.value : null});
                  }}
                  value={treatmentOptions.controlled === true || treatmentOptions.controlled === false ? {value:treatmentOptions.controlled, label:treatmentOptions.controlled === true ? 'True' : 'False'} : null}
                />
                <Button className="btn btn-primary" style={{maxHeight:"35px", width:"100%"}} onClick={() => {tempSearchTerm.current.value !== searchTerm ? setSearchTerm(tempSearchTerm.current.value) : setTriggerRefresh(!triggerRefresh);}} disabled={isDisabled}>Apply</Button>
                <Button variant="outline-light" style={{maxHeight:"35px", width:"100%", marginTop:"10px"}} onClick={handleClear}>Clear</Button>
              </Col>
              <Row className="gx-2 pe-0">
                <Col>
                  <DateRangePicker
                    data-enable-time={false}
                    name={`treatment_scheduled_start`}
                    id={`treatment_scheduled_start`}
                    mode="single"
                    placeholder={"Filter by Scheduled Start Date"}
                    style={{height:"36px"}}
                    ref={scheduledEndRef}
                    clearable="true"
                    value={treatmentOptions.scheduled_start || null}
                    onChange={(dateRange) => {
                      setTreatmentOptions({...treatmentOptions, scheduled_start: dateRange.length ? dateRange[0] : null});
                    }}
                  />
                </Col>
                <Col className="pe-0">
                  <DateRangePicker
                    data-enable-time={false}
                    name={`treatment_scheduled_end`}
                    id={`treatment_scheduled_end`}
                    mode="single"
                    placeholder={"Filter by Scheduled End Date"}
                    style={{height:"36px"}}
                    ref={scheduledEndRef}
                    clearable="true"
                    value={treatmentOptions.scheduled_end || null}
                    onChange={(dateRange) => {
                      setTreatmentOptions({...treatmentOptions, scheduled_end: dateRange.length ? dateRange[0] : null});
                    }}
                  />
                </Col>
                <Col xs="3"/>
              </Row>
              <Row className="gx-2 pe-0 mb-3" style={{marginTop:"10px"}}>
                <Col>
                  <DateRangePicker
                    data-enable-time={false}
                    name={`treatment_administered_start`}
                    id={`treatment_administered_start`}
                    mode="single"
                    placeholder={"Filter by Administered Start Date"}
                    style={{height:"36px"}}
                    ref={administeredStartRef}
                    clearable="true"
                    value={treatmentOptions.administered_start || null}
                    onChange={(dateRange) => {
                      setTreatmentOptions({...treatmentOptions, administered_start: dateRange.length ? dateRange[0] : null});
                    }}
                  />
                </Col>
                <Col className="pe-0">
                  <DateRangePicker
                    data-enable-time={false}
                    name={`treatment_administered_end`}
                    id={`treatment_administered_end`}
                    mode="single"
                    placeholder={"Filter by Administered End Date"}
                    style={{height:"36px"}}
                    ref={administeredEndRef}
                    clearable="true"
                    value={treatmentOptions.administered_end || null}
                    onChange={(dateRange) => {
                      setTreatmentOptions({...treatmentOptions, administered_end: dateRange.length ? dateRange[0] : null});
                    }}
                  />
                </Col>
                <Col xs="3"/>
              </Row>
            </Row>
          </Card.Body>
        </Card>
        </div>
      </Collapse>
      : vetObject === 'diagnostics' ?
      <Collapse in={showFilters} className="mb-3">
      <div>
        <Card className="border rounded d-flex" style={{width:"100%"}}>
          <Card.Body>
            <Row className="gx-2">
              <Col xs={"9"} style={{textTransform:"capitalize"}}>
                <Select
                  id="diagnosticDropdown"
                  name="diagnostic"
                  type="text"
                  placeholder="Select Diagnostic"
                  options={diagnosticChoices}
                  styles={customStyles}
                  isClearable={true}
                  ref={diagnosticRef}
                  onChange={(instance) => {
                    setDiagnosticOptions({...diagnosticOptions, diagnostic: instance ? instance.value : ''})
                  }}
                  value={diagnosticOptions.diagnostic ? diagnosticChoices.filter(diagnostic => diagnostic.id === diagnosticOptions.diagnostic)[0] : null}
                />
                <Typeahead
                  id="status"
                  name="status"
                  multiple
                  onChange={(values) => {
                    setDiagnosticOptions({...diagnosticOptions, status: values.map(option => option.value)});
                  }}
                  ref={diagnosticStatusRef}
                  options={orderStatusChoices}
                  placeholder="Filter by Status..."
                  className="status-typeahead mb-2 no-wrap-container w-100"
                  selected={orderStatusChoices.filter(choice => diagnosticOptions.status.includes(choice.value))}
                  inputProps={{ className: 'custom-typeahead-input' }}
                >
                  {({ isMenuShown, toggleMenu }) => (
                    <ToggleButton isOpen={isMenuShown} onClick={(e) => toggleMenu()} />
                  )}
                </Typeahead>
                <Select
                  id="performerDropdown"
                  name="performer"
                  type="text"
                  placeholder="Select Performer"
                  options={assignees}
                  styles={customStyles}
                  isClearable={true}
                  ref={performerRef}
                  onChange={(instance) => {
                    setDiagnosticOptions({...diagnosticOptions, performer: instance ? instance.value : null});
                  }}
                  value={diagnosticOptions.performer ? assignees.filter(assignee => assignee.value === diagnosticOptions.performer)[0] : null}
                />
                <Typeahead
                  id="species"
                  name="species"
                  multiple
                  onChange={(values) => {
                    setDiagnosticOptions({...diagnosticOptions, species: values.map(option => option.value)});
                  }}
                  ref={diagnosticSpeciesRef}
                  options={speciesChoices}
                  placeholder="Filter by Patient Species..."
                  className="species-typeahead mb-2 no-wrap-container w-100"
                  selected={speciesChoices.filter(choice => diagnosticOptions.species.includes(choice.value))}
                  inputProps={{ className: 'custom-typeahead-input' }}
                >
                  {({ isMenuShown, toggleMenu }) => (
                    <ToggleButton isOpen={isMenuShown} onClick={(e) => toggleMenu()} />
                  )}
                </Typeahead>
                <Typeahead
                  id="shelter"
                  name="shelter"
                  multiple
                  onChange={(values) => {
                    setDiagnosticOptions({...diagnosticOptions, shelter: values.map(option => option.value)});
                  }}
                  ref={diagnosticShelterRef}
                  options={shelters.options}
                  placeholder="Filter by Patient Shelter..."
                  className="shelter-typeahead mb-2 no-wrap-container w-100"
                  selected={shelters.options.filter(choice => diagnosticOptions.shelter.includes(choice.value))}
                  inputProps={{ className: 'custom-typeahead-input' }}
                >
                  {({ isMenuShown, toggleMenu }) => (
                    <ToggleButton isOpen={isMenuShown} onClick={(e) => toggleMenu()} />
                  )}
                </Typeahead>
              </Col>
              <Col className="flex-grow-1" xs="3">
                <Button className="btn btn-primary" style={{maxHeight:"35px", width:"100%"}} onClick={() => {tempSearchTerm.current.value !== searchTerm ? setSearchTerm(tempSearchTerm.current.value) : setTriggerRefresh(!triggerRefresh);}} disabled={isDisabled}>Apply</Button>
                <Button variant="outline-light" style={{maxHeight:"35px", width:"100%", marginTop:"10px"}} onClick={handleClear}>Clear</Button>
              </Col>
              <Row className="gx-2 pe-0">
                <Col>
                  <DateRangePicker
                    data-enable-time={false}
                    name={`diagnostic_ordered_start`}
                    id={`diagnostic_ordered_start`}
                    mode="single"
                    placeholder={"Filter by Scheduled Start Date"}
                    style={{height:"36px"}}
                    ref={scheduledEndRef}
                    clearable="true"
                    value={diagnosticOptions.ordered_start || null}
                    onChange={(dateRange) => {
                      setDiagnosticOptions({...diagnosticOptions, ordered_start: dateRange.length ? dateRange[0] : null});
                    }}
                  />
                </Col>
                <Col className="pe-0">
                  <DateRangePicker
                    data-enable-time={false}
                    name={`diagnostic_ordered_end`}
                    id={`diagnostic_ordered_end`}
                    mode="single"
                    placeholder={"Filter by Scheduled End Date"}
                    style={{height:"36px"}}
                    ref={scheduledEndRef}
                    clearable="true"
                    value={diagnosticOptions.ordered_end || null}
                    onChange={(dateRange) => {
                      setDiagnosticOptions({...diagnosticOptions, ordered_end: dateRange.length ? dateRange[0] : null});
                    }}
                  />
                </Col>
                <Col xs="3"/>
              </Row>
              <Row className="gx-2 pe-0" style={{marginTop:"10px"}}>
                <Col>
                  <DateRangePicker
                    data-enable-time={false}
                    name={`diagnostic_complete_start`}
                    id={`diagnostic_complete_start`}
                    mode="single"
                    placeholder={"Filter by Completed Start Date"}
                    style={{height:"36px"}}
                    ref={diagnosticCompleteStartRef}
                    clearable="true"
                    value={diagnosticOptions.complete_start || null}
                    onChange={(dateRange) => {
                      setDiagnosticOptions({...diagnosticOptions, complete_start: dateRange.length ? dateRange[0] : null});
                    }}
                  />
                </Col>
                <Col className="pe-0">
                  <DateRangePicker
                    data-enable-time={false}
                    name={`diagnostic_complete_end`}
                    id={`diagnostic_complete_end`}
                    mode="single"
                    placeholder={"Filter by Completed End Date"}
                    style={{height:"36px"}}
                    ref={diagnosticCompleteEndRef}
                    clearable="true"
                    value={diagnosticOptions.complete_end || null}
                    onChange={(dateRange) => {
                      setDiagnosticOptions({...diagnosticOptions, complete_end: dateRange.length ? dateRange[0] : null});
                    }}
                  />
                </Col>
                <Col xs="3"/>
              </Row>
            </Row>
          </Card.Body>
        </Card>
        </div>
      </Collapse> : vetObject === 'procedures' ?
      <Collapse in={showFilters} className="mb-3">
      <div>
        <Card className="border rounded d-flex" style={{width:"100%"}}>
          <Card.Body>
            <Row className="gx-2">
              <Col xs={"9"} style={{textTransform:"capitalize"}}>
                <Select
                  id="procedureDropdown"
                  name="procedure"
                  type="text"
                  placeholder="Select Procedure"
                  options={procedureChoices}
                  styles={customStyles}
                  isClearable={true}
                  ref={procedureRef}
                  onChange={(instance) => {
                    setProcedureOptions({...procedureOptions, procedure: instance ? instance.value : ''})
                  }}
                  value={procedureOptions.procedure ? procedureChoices.filter(procedure => procedure.id === procedureOptions.procedure)[0] : null}
                />
                <Typeahead
                  id="status"
                  name="status"
                  multiple
                  onChange={(values) => {
                    setProcedureOptions({...procedureOptions, status: values.map(option => option.value)});
                  }}
                  ref={procedureStatusRef}
                  options={orderStatusChoices}
                  placeholder="Filter by Status..."
                  className="status-typeahead mb-2 no-wrap-container w-100"
                  selected={orderStatusChoices.filter(choice => procedureOptions.status.includes(choice.value))}
                  inputProps={{ className: 'custom-typeahead-input' }}
                >
                  {({ isMenuShown, toggleMenu }) => (
                    <ToggleButton isOpen={isMenuShown} onClick={(e) => toggleMenu()} />
                  )}
                </Typeahead>
                <Select
                  id="performerDropdown"
                  name="performer"
                  type="text"
                  placeholder="Select Performer"
                  options={assignees}
                  styles={customStyles}
                  isClearable={true}
                  ref={performerRef}
                  onChange={(instance) => {
                    setProcedureOptions({...procedureOptions, performer: instance ? instance.value : null});
                  }}
                  value={procedureOptions.performer ? assignees.filter(assignee => assignee.value === procedureOptions.performer)[0] : null}
                />
                <Typeahead
                  id="species"
                  name="species"
                  multiple
                  onChange={(values) => {
                    setProcedureOptions({...procedureOptions, species: values.map(option => option.value)});
                  }}
                  ref={procedureSpeciesRef}
                  options={speciesChoices}
                  placeholder="Filter by Patient Species..."
                  className="species-typeahead mb-2 no-wrap-container w-100"
                  selected={speciesChoices.filter(choice => procedureOptions.species.includes(choice.value))}
                  inputProps={{ className: 'custom-typeahead-input' }}
                >
                  {({ isMenuShown, toggleMenu }) => (
                    <ToggleButton isOpen={isMenuShown} onClick={(e) => toggleMenu()} />
                  )}
                </Typeahead>
                <Typeahead
                  id="shelter"
                  name="shelter"
                  multiple
                  onChange={(values) => {
                    setProcedureOptions({...procedureOptions, shelter: values.map(option => option.value)});
                  }}
                  ref={procedureShelterRef}
                  options={shelters.options}
                  placeholder="Filter by Patient Shelter..."
                  className="shelter-typeahead mb-2 no-wrap-container w-100"
                  selected={shelters.options.filter(choice => procedureOptions.shelter.includes(choice.value))}
                  inputProps={{ className: 'custom-typeahead-input' }}
                >
                  {({ isMenuShown, toggleMenu }) => (
                    <ToggleButton isOpen={isMenuShown} onClick={(e) => toggleMenu()} />
                  )}
                </Typeahead>
              </Col>
              <Col className="flex-grow-1" xs="3">
                <Button className="btn btn-primary" style={{maxHeight:"35px", width:"100%"}} onClick={() => {tempSearchTerm.current.value !== searchTerm ? setSearchTerm(tempSearchTerm.current.value) : setTriggerRefresh(!triggerRefresh);}} disabled={isDisabled}>Apply</Button>
                <Button variant="outline-light" style={{maxHeight:"35px", width:"100%", marginTop:"10px"}} onClick={handleClear}>Clear</Button>
              </Col>
              <Row className="gx-2 pe-0">
                <Col>
                  <DateRangePicker
                    data-enable-time={false}
                    name={`procedure_ordered_start`}
                    id={`procedure_ordered_start`}
                    mode="single"
                    placeholder={"Filter by Scheduled Start Date"}
                    style={{height:"36px"}}
                    ref={scheduledEndRef}
                    clearable="true"
                    value={procedureOptions.ordered_start || null}
                    onChange={(dateRange) => {
                      setProcedureOptions({...procedureOptions, ordered_start: dateRange.length ? dateRange[0] : null});
                    }}
                  />
                </Col>
                <Col className="pe-0">
                  <DateRangePicker
                    data-enable-time={false}
                    name={`procedure_ordered_end`}
                    id={`procedure_ordered_end`}
                    mode="single"
                    placeholder={"Filter by Scheduled End Date"}
                    style={{height:"36px"}}
                    ref={scheduledEndRef}
                    clearable="true"
                    value={procedureOptions.ordered_end || null}
                    onChange={(dateRange) => {
                      setProcedureOptions({...procedureOptions, ordered_end: dateRange.length ? dateRange[0] : null});
                    }}
                  />
                </Col>
                <Col xs="3"/>
              </Row>
              <Row className="gx-2 pe-0" style={{marginTop:"10px"}}>
                <Col>
                  <DateRangePicker
                    data-enable-time={false}
                    name={`procedure_complete_start`}
                    id={`procedure_complete_start`}
                    mode="single"
                    placeholder={"Filter by Completed Start Date"}
                    style={{height:"36px"}}
                    ref={procedureCompleteStartRef}
                    clearable="true"
                    value={procedureOptions.complete_start || null}
                    onChange={(dateRange) => {
                      setProcedureOptions({...procedureOptions, complete_start: dateRange.length ? dateRange[0] : null});
                    }}
                  />
                </Col>
                <Col className="pe-0">
                  <DateRangePicker
                    data-enable-time={false}
                    name={`procedure_complete_end`}
                    id={`procedure_complete_end`}
                    mode="single"
                    placeholder={"Filter by Completed End Date"}
                    style={{height:"36px"}}
                    ref={procedureCompleteEndRef}
                    clearable="true"
                    value={procedureOptions.complete_end || null}
                    onChange={(dateRange) => {
                      setProcedureOptions({...procedureOptions, complete_end: dateRange.length ? dateRange[0] : null});
                    }}
                  />
                </Col>
                <Col xs="3"/>
              </Row>
            </Row>
          </Card.Body>
        </Card>
        </div>
      </Collapse> : ""}
      </Form>
      {vetObject === 'vet_requests' && data.vet_requests.map((vet_request, index) => (
      <Row key={vet_request.id_for_incident} className="ms-0 me-0 mb-3">
        <Card className="border rounded ps-0 pe-0" style={{height:"120px", whiteSpace:"nowrap", overflow:"hidden"}}>
          <Row className="ms-0 me-0 ps-0 pe-0 w-100" style={{flexWrap:"nowrap", height:"120px"}}>
            <Col style={{overflow:"hidden"}} className="hover-div ps-0 pe-0 ms-0 me-0">
              <div className="rounded" style={{paddingTop:"6px", paddingBottom:"8px", paddingLeft:"10px", marginLeft:"-1px", marginTop: "-1px", fontSize:"18px", width:"100%", backgroundColor:"rgb(158 153 153)"}}>
                <OverlayTrigger
                  key={"medical-record-details"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-medical-record-details`}>
                      Medical record details
                    </Tooltip>
                  }
                >
                  <Link href={"/" + organization + "/" + incident + "/vet/medrecord/" + vet_request.medical_record}><FontAwesomeIcon icon={faDotCircle} className="me-2" inverse /></Link>
                </OverlayTrigger>
                VR#{vet_request.id_for_incident} - {priorityText[vet_request.priority]}
                <span className="float-end" style={{marginRight:"-2px"}}>
                {vet_request.status === 'Closed' ?
                  <OverlayTrigger
                    key={"complete-vet-request"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-complete-vet-request`}>
                        Veterinary request is completed.
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faCheckSquare} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                  </OverlayTrigger>
                  : vet_request.status === 'Canceled' ?
                  <OverlayTrigger
                    key={"not-administered-vet-request"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-not-administered-vet-request`}>
                        Veterinary request was canceled.
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faSquareX} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                  </OverlayTrigger>
                  :
                  <OverlayTrigger
                    key={"awaiting-action-vet-request"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-awaiting-action-vet-request`}>
                        Veterinary request is pending action.
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faSquareExclamation} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                  </OverlayTrigger>
                  }
                </span>
              </div>
              <Row>
                <Col xs={2} className="border-end" style={{height:"80px", width:"80px", flex: 'none'}}>
                  <FontAwesomeIcon icon={faUserDoctorMessage} size="4x" className="treatment-icon" transform={'down-3 left-2 shrink-1'} inverse />
                </Col>
                <Col xs={10}>
                  <Row style={{marginTop:"6px"}}>
                    <Col xs={4}>
                      <b>Patient: </b>A#{vet_request.animal_object.id_for_incident} - <span>{capitalize(vet_request.animal_object.species_string)}</span>
                    </Col>
                    {/* <Col xs={4}>
                      <b>Species:</b> <span  style={{textTransform:"capitalize"}}>{vet_request.animal_object.species_string}</span>
                    </Col> */}
                    <Col xs={4}>
                      <b>Name: </b>{vet_request.animal_object.name || "Unknown Name"}
                    </Col>
                    <Col xs={4}>
                      <b>Location: </b>{vet_request.animal_object.shelter_object ? <span>{vet_request.animal_object.shelter_object.name} {vet_request.animal_object.room_name ? <span> - {vet_request.animal_object.room_name}</span> : ""}</span> : "Field"}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={4}>
                      <b>Scheduled: </b><Moment format="MM/DD/YY">{vet_request.open}</Moment>
                    </Col>
                    <Col xs={4}>
                      <b>Opener: </b>{vet_request.requested_by_object.first_name} {vet_request.requested_by_object.last_name}
                    </Col>
                  </Row>
                  <Row style={{overflow:"visible"}}>
                    <Col xs={12}>
                      <b>Complaints: </b><span title={vet_request.complaints_text}>{vet_request.complaints_text}</span>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </Row>
      ))}
      {vetObject === 'treatments' && data.treatments.map((treatment_request, index) => (
      <Row key={treatment_request.id_for_incident} className="ms-0 me-0 mb-3">
        <Card className="border rounded ps-0 pe-0" style={{height:"120px", whiteSpace:"nowrap", overflow:"hidden"}}>
          <Row className="ms-0 me-0 ps-0 pe-0 w-100" style={{flexWrap:"nowrap", height:"120px"}}>
            <Col style={{overflow:"hidden"}} className="hover-div ps-0 pe-0 ms-0 me-0">
              <Row className="ms-0 me-0 ps-0 pe-0" style={{}}>
                <div className="rounded pe-0" style={{height:"41px", paddingTop:"6px", marginLeft:"-1px", marginTop: "-1px", fontSize:"18px", width:"100%", backgroundColor:"rgb(158 153 153)"}}>
                  <OverlayTrigger
                    key={"treatment-details"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-treatment-details`}>
                        Treatment details
                      </Tooltip>
                    }
                  >
                    <Link href={"/" + organization + "/" + incident + "/vet/treatment/" + treatment_request.treatment_plan}><FontAwesomeIcon icon={faDotCircle} className="me-2" inverse /></Link>
                  </OverlayTrigger>
                  {treatment_request.treatment_object ? treatment_request.treatment_object.description : ""}
                  {treatment_request.treatment_object && treatment_request.treatment_object.controlled ?
                  <OverlayTrigger
                    key={"treatment-controlled"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-treatment-controlled`}>
                        This treatment is a controlled substance.
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faPrescription} className="ms-1" inverse />
                  </OverlayTrigger> : ""}
                  <span className="float-end" style={{marginRight:"-2px"}}>
                  {treatment_request.status === 'Completed' ?
                    <OverlayTrigger
                      key={"complete-treatment"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-complete-treatment`}>
                          Treatment is completed.
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faCheckSquare} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                    </OverlayTrigger>
                    : treatment_request.status === 'Not Administered' ?
                    <OverlayTrigger
                      key={"not-administered-treatment"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-not-administered-treatment`}>
                          Treatment was not administered.
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faSquareX} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                    </OverlayTrigger>
                    : treatment_request.status === 'Scheduled' ?
                    <OverlayTrigger
                      key={"scheduled-treatment"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-scheduled-treatment`}>
                          Treatment is scheduled for a future date/time.
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faSquareExclamation} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                    </OverlayTrigger>
                    :
                    <OverlayTrigger
                      key={"pending-treatment"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-pending-treatment`}>
                          Treatment is pending action.
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faSquareExclamation} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                    </OverlayTrigger>
                    }
                  </span>
                </div>
              </Row>
              <Row className="ms-0 me-0 ps-0 pe-0">
                <Col className="border-end" style={{height:"80px", width:"80px", flex: 'none'}}>
                  {treatment_request.treatment_object && ['Eye Medication','Ear Medication'].includes(treatment_request.treatment_object.category) ?
                    <FontAwesomeIcon icon={faEyeDropper} size="4x" className="treatment-icon" style={{marginTop:"9px", marginLeft:"-2px"}} inverse />
                    : treatment_request.treatment_object && treatment_request.treatment_object.category === 'Patient Care' ?
                    <FontAwesomeIcon icon={faHeart} size="4x" className="treatment-icon" style={{marginTop:"10px", marginLeft:"-2px"}} inverse />
                    : treatment_request.treatment_object && treatment_request.treatment_object && treatment_request.treatment_object.unit === 'ml' ?
                    <FontAwesomeIcon icon={faSyringe} size="4x" className="treatment-icon" style={{marginTop:"10px", marginLeft:"-7px"}} inverse />
                  :
                    <FontAwesomeIcon icon={faPrescriptionBottlePill} size="4x" className="treatment-icon" style={{marginTop:"10px", marginLeft:"-7px"}} inverse />
                  }
                </Col>
                <Col>
                  <Row style={{marginTop:"6px"}}>
                    <Col xs={4}>
                      <b>Patient: </b>A#{treatment_request.animal_object.id_for_incident} - <span>{capitalize(treatment_request.animal_object.species_string)}</span>
                    </Col>
                    <Col xs={4}>
                      <b>Name: </b>{treatment_request.animal_object.name || "Unknown Name"}
                    </Col>
                    <Col xs={4}>
                      <b>Location: </b>{treatment_request.animal_object.shelter_object ? <span>{treatment_request.animal_object.shelter_object.name} {treatment_request.animal_object.room_name ? <span> - {treatment_request.animal_object.room_name}</span> : ""}</span> : "Field"}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={4}>
                      <b>Scheduled: </b><Moment format="MM/DD/YY, HH:MM">{treatment_request.suggested_admin_time}</Moment>
                    </Col>
                    <Col xs={4}>
                      <b>Administered: </b>{treatment_request.actual_admin_time ? <Moment format="MM/DD/YY, HH:MM">{treatment_request.actual_admin_time}</Moment> : "N/A"}
                    </Col>
                    <Col xs={4}>
                      <b>Administrator: </b>{!treatment_request.assignee_object ? "N/A" : ""}{treatment_request.assignee_object && treatment_request.assignee_object.first_name} {treatment_request.assignee_object && treatment_request.assignee_object.last_name}
                    </Col>
                  </Row>
                  <Row style={{overflow:"visible"}}>
                    <Col xs={4}>
                      <b>Quantity: </b>{treatment_request.quantity}
                    </Col>
                    <Col xs={4}>
                      <b>Unit: </b>{treatment_request.unit || '-'}
                    </Col>
                    <Col xs={3}>
                      <b>Route: </b>{treatment_request.route || '-'}
                    </Col>
                    <Col xs={1} style={{marginRight:"0px"}}>
                      <span className="float-end"><b>Num: </b>{treatment_request.num || '-'}</span>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </Row>
      ))}
      {vetObject === 'diagnostics' && data.diagnostics.map((diagnostic, index) => (
      <Row key={diagnostic.id_for_incident} className="ms-0 me-0 mb-3">
        <Card className="border rounded ps-0 pe-0" style={{height:"120px", whiteSpace:"nowrap", overflow:"hidden"}}>
          <Row className="ms-0 me-0 ps-0 pe-0 w-100" style={{flexWrap:"nowrap", height:"120px"}}>
            <Col style={{overflow:"hidden"}} className="hover-div ps-0 pe-0 ms-0 me-0">
              <div className="rounded" style={{paddingTop:"6px", paddingBottom:"8px", paddingLeft:"10px", marginLeft:"-1px", marginTop: "-1px", fontSize:"18px", width:"100%", backgroundColor:"rgb(158 153 153)"}}>
                <OverlayTrigger
                  key={"diagnostic-details"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-diagnostic-details`}>
                      Treatment details
                    </Tooltip>
                  }
                >
                  <Link href={"/" + organization + "/" + incident + "/vet/diagnosticresult/edit/" + diagnostic.id}><FontAwesomeIcon icon={faDotCircle} className="me-2" inverse /></Link>
                </OverlayTrigger>
                {diagnostic.other_name ? diagnostic.other_name : diagnostic.name}
                {diagnostic.result ? " - " + diagnostic.result : ""}
                <span className="float-end" style={{marginRight:"-2px"}}>
                {diagnostic.status === 'Completed' ?
                  <OverlayTrigger
                    key={"complete-diagnostic"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-complete-diagnostic`}>
                        Diagnostic is completed.
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faCheckSquare} size="3x" className="ms-1 diagnostic-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                  </OverlayTrigger>
                  : diagnostic.status === 'Scheduled' ?
                  <OverlayTrigger
                    key={"scheduled-diagnostic"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-scheduled-diagnostic`}>
                        Diagnostic is scheduled for a future date/time.
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faSquareExclamation} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                  </OverlayTrigger>
                  :
                  <OverlayTrigger
                    key={"pending-diagnostic"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-pending-diagnostic`}>
                        Diagnostic is pending action.
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faSquareExclamation} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                  </OverlayTrigger>
                  }
                </span>
              </div>
              <Row>
                <Col xs={2} className="border-end" style={{height:"80px", width:"80px", flex: 'none'}}>
                  {diagnostic.name.toLowerCase().includes('needle') || diagnostic.other_name.toLowerCase().includes('needle') ?
                    <FontAwesomeIcon icon={faSyringe} size="4x" className="treatment-icon" style={{marginTop:"10px", marginLeft:"-7px"}} inverse />
                  : diagnostic.name.toLowerCase().includes('istat') || diagnostic.other_name.toLowerCase().includes('istat') ?
                  <span className="fa-layers" style={{marginLeft:"16px"}}>
                    <FontAwesomeIcon icon={faRectangleVertical} size="2x" className="treatment-icon" style={{marginTop:"7px", marginLeft:"9px"}} transform={'shrink-2 down-17 left-4'} inverse />
                    <FontAwesomeIcon icon={faMobileScreenButton} size="3x" className="treatment-icon" style={{marginLeft:"-1px", marginTop:"-14px"}} transform={'shrink-1 down-5 left-1'} inverse />
                  </span>
                  : diagnostic.name.toLowerCase().includes('culture') || diagnostic.other_name.toLowerCase().includes('culture') ?
                    <FontAwesomeIcon icon={faRing} size="4x" className="treatment-icon" style={{marginTop:"10px", marginLeft:"-2px"}} inverse />
                  : diagnostic.name.toLowerCase().includes('schirmer') || diagnostic.other_name.toLowerCase().includes('schirmer') ?
                    <FontAwesomeIcon icon={faEye} size="4x" className="treatment-icon" style={{marginTop:"11px", marginLeft:"-6px"}} inverse />
                  : diagnostic.name.toLowerCase().includes('eye') || diagnostic.other_name.toLowerCase().includes('eye') ?
                    <FontAwesomeIcon icon={faEyeDropper} size="4x" className="treatment-icon" style={{marginTop:"9px", marginLeft:"-2px"}} inverse />
                  : diagnostic.name.toLowerCase().includes('ultrasound') || diagnostic.other_name.toLowerCase().includes('ultrasound') ?
                    <span className="fa-layers" style={{marginLeft:"16px"}}>
                      <FontAwesomeIcon icon={faWifi} size="2x" className="treatment-icon" style={{marginTop:"7px", marginLeft:"-2px"}} transform={'shrink-1 up-2 right-8 rotate-49'} inverse />
                      <FontAwesomeIcon icon={faPeriod} size="2x" className="fa-move-up" style={{marginLeft:"2px", marginTop:"-1px", color:"#303030"}} transform={'down-13 right-0'} inverse />
                      <FontAwesomeIcon icon={faFlashlight} size="3x" className="treatment-icon" transform={'shrink-1 down-14 left-10 rotate-315'} inverse />
                    </span>
                  : diagnostic.name.toLowerCase().includes('swab') || diagnostic.other_name.toLowerCase().includes('swab') ?
                    <span className="fa-layers" style={{marginLeft:"16px"}}>
                      <FontAwesomeIcon icon={faRectangle} size="4x" className="treatment-icon" transform={'left-8 down-4'} style={{marginTop:"-15px", marginRight:"-5px", height:"100%", width:"100%", transform:"rotate(135deg) scale(4.25, 0.3)"}} inverse />
                      <FontAwesomeIcon icon={faCircle} size="1x" className="treatment-icon" transform={'shrink-8 down-1 right-18'} style={{marginTop:"6px", marginRight:"-10px", height:"100%", width:"100%", transform:"rotate(135deg) scale(1.6, 1)"}} inverse />
                      <FontAwesomeIcon icon={faCircle} size="1x" className="treatment-icon" transform={'shrink-8 down-46 left-16'} style={{marginTop:"6px", height:"100%", width:"100%", transform:"rotate(135deg) scale(1.6, 1)"}} inverse />
                    </span>
                  :
                    <FontAwesomeIcon icon={faVial} size="4x" className="treatment-icon" style={{marginTop:"10px", marginLeft:"-2px"}} inverse />
                  }
                </Col>
                <Col xs={10}>
                  <Row style={{marginTop:"6px"}}>
                    <Col xs={4}>
                      <b>Patient: </b>A#{diagnostic.animal_object.id_for_incident} - <span>{capitalize(diagnostic.animal_object.species_string)}</span>
                    </Col>
                    <Col xs={4}>
                      <b>Name: </b>{diagnostic.animal_object.name || "Unknown Name"}
                    </Col>
                    <Col xs={4}>
                      <b>Location: </b>{diagnostic.animal_object.shelter_object ? <span>{diagnostic.animal_object.shelter_object.name} {diagnostic.animal_object.room_name ? <span> - {diagnostic.animal_object.room_name}</span> : ""}</span> : "Field"}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={4}>
                      <b>Scheduled: </b><Moment format="MM/DD/YY">{diagnostic.open}</Moment>
                    </Col>
                    <Col xs={4}>
                      <b>Completed: </b>{diagnostic.complete ? <Moment format="MM/DD/YY">{diagnostic.complete}</Moment> : "N/A"}
                    </Col>
                    <Col xs={4}>
                      <b>Performer: </b>{!diagnostic.performer_object ? "N/A" : ""}{diagnostic.performer_object && diagnostic.performer_object.first_name} {diagnostic.performer_object && diagnostic.performer_object.last_name}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <b>Notes: </b>{diagnostic.notes || "N/A"}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </Row>
      ))}
      {vetObject === 'procedures' && data.procedures.map((procedure, index) => (
      <Row key={procedure.id_for_incident} className="ms-0 me-0 mb-3">
        <Card className="border rounded ps-0 pe-0" style={{height:"120px", whiteSpace:"nowrap", overflow:"hidden"}}>
          <Row className="ms-0 me-0 ps-0 pe-0 w-100" style={{flexWrap:"nowrap", height:"120px"}}>
            <Col style={{overflow:"hidden"}} className="hover-div ps-0 pe-0 ms-0 me-0">
              <div className="rounded" style={{paddingTop:"6px", paddingBottom:"8px", paddingLeft:"10px", marginLeft:"-1px", marginTop: "-1px", fontSize:"18px", width:"100%", backgroundColor:"rgb(158 153 153)"}}>
                <OverlayTrigger
                  key={"procedure-details"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-procedure-details`}>
                      Procedure details
                    </Tooltip>
                  }
                >
                  <Link href={"/" + organization + "/" + incident + "/vet/procedureresult/edit/" + procedure.id}><FontAwesomeIcon icon={faDotCircle} className="me-2" inverse /></Link>
                </OverlayTrigger>
                {procedure.other_name ? procedure.other_name : procedure.name}
                {procedure.result ? " - " + procedure.result : ""}
                <span className="float-end" style={{marginRight:"-2px"}}>
                {procedure.status === 'Completed' ?
                  <OverlayTrigger
                    key={"complete-procedure"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-complete-procedure`}>
                        Procedure is completed.
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faCheckSquare} size="3x" className="ms-1 procedure-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                  </OverlayTrigger>
                  : procedure.status === 'Scheduled' ?
                  <OverlayTrigger
                    key={"scheduled-procedure"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-scheduled-procedure`}>
                        Procedure is scheduled for a future date/time.
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faSquareExclamation} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                  </OverlayTrigger>
                  :
                  <OverlayTrigger
                    key={"pending-procedure"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-pending-procedure`}>
                        Procedure is pending action.
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faSquareExclamation} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                  </OverlayTrigger>
                  }
                </span>
              </div>
              <Row>
                <Col xs={2} className="border-end" style={{height:"80px", width:"80px", flex: 'none'}}>
                  {procedure.name.toLowerCase().includes('bandage') || procedure.other_name.toLowerCase().includes('bandage') || procedure.name.toLowerCase().includes('splint') || procedure.other_name.toLowerCase().includes('splint') ?
                    <FontAwesomeIcon icon={faBandage} size="4x" className="treatment-icon" style={{marginTop:"10px", marginLeft:"-6px"}} transform={'shrink-1'} inverse />
                  : procedure.name.toLowerCase().includes('hydro') || procedure.other_name.toLowerCase().includes('hydro') || procedure.name.toLowerCase().includes('water') || procedure.other_name.toLowerCase().includes('water') ?
                    <FontAwesomeIcon icon={faWater} size="4x" className="treatment-icon" style={{marginTop:"10px", marginLeft:"-2px"}} transform={'grow-1'} inverse />
                  : procedure.name.toLowerCase().includes('eye') || procedure.other_name.toLowerCase().includes('eye') ?
                    <FontAwesomeIcon icon={faEye} size="4x" className="treatment-icon" style={{marginTop:"11px", marginLeft:"-6px"}} inverse />
                  : procedure.name.toLowerCase().includes('clean') || procedure.other_name.toLowerCase().includes('clean') ?
                    <FontAwesomeIcon icon={faSoap} size="4x" className="treatment-icon" style={{marginTop:"12px", marginLeft:"-2px"}} transform={'grow-1'} inverse />
                  : procedure.name.toLowerCase().includes('centesis') || procedure.other_name.toLowerCase().includes('centesis') || procedure.name.toLowerCase().includes('needle') || procedure.other_name.toLowerCase().includes('needle') ?
                    <FontAwesomeIcon icon={faSyringe} size="4x" className="treatment-icon" style={{marginTop:"10px", marginLeft:"-7px"}} inverse />
                  : procedure.name.toLowerCase().includes('tube') || procedure.other_name.toLowerCase().includes('tube') ?
                    <span className="fa-layers" style={{marginLeft:"16px"}}>
                      <FontAwesomeIcon icon={faSpiral} size="4x" className="treatment-icon" transform={'left-5 down-8'} inverse />
                      <FontAwesomeIcon icon={faRectangle} size="1x" className="treatment-icon" transform={'shrink-5 rotate-138 down-1 left-8'} inverse />
                    </span>
                  :
                    <FontAwesomeIcon icon={faScalpelLineDashed} size="4x" className="treatment-icon" style={{marginTop:"11px", marginLeft:"-8px"}} transform={"shrink-1"} inverse />
                  }
                </Col>
                <Col xs={10}>
                  <Row style={{marginTop:"6px"}}>
                    <Col xs={4}>
                      <b>Patient: </b>A#{procedure.animal_object.id_for_incident} - <span>{capitalize(procedure.animal_object.species_string)}</span>
                    </Col>
                    <Col xs={4}>
                      <b>Name: </b>{procedure.animal_object.name || "Unknown Name"}
                    </Col>
                    <Col xs={4}>
                      <b>Location: </b>{procedure.animal_object.shelter_object ? <span>{procedure.animal_object.shelter_object.name} {procedure.animal_object.room_name ? <span> - {procedure.animal_object.room_name}</span> : ""}</span> : "Field"}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={4}>
                      <b>Scheduled: </b><Moment format="MM/DD/YY">{procedure.open}</Moment>
                    </Col>
                    <Col xs={4}>
                      <b>Completed: </b>{procedure.complete ? <Moment format="MM/DD/YY">{procedure.complete}</Moment> : "N/A"}
                    </Col>
                    <Col xs={4}>
                      <b>Performer: </b>{!procedure.performer_object ? "N/A" : ""}{procedure.performer_object && procedure.performer_object.first_name} {procedure.performer_object && procedure.performer_object.last_name}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <b>Notes: </b>{procedure.notes || "N/A"}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </Row>
      ))}
      {data.isFetching ? <p>{'Fetching ' + (vetObject === 'vet_requests' ? 'veterinary requests' : vetObject === 'treatments' ? 'treatments' : vetObject === 'diagnostics' ? 'diagnostics' : 'procedures') + '...'}</p> : ""}
      {!data.isFetching && vetObject === 'vet_requests' && data.vet_requests.length === 0 ? <p>No veterinary requests found.</p> : ""}
      {!data.isFetching && vetObject === 'treatments' && data.treatments.length === 0 ? <p>No treatments found.</p> : ""}
      {!data.isFetching && vetObject === 'diagnostics' && data.diagnostics.length === 0 ? <p>No diagnostics found.</p> : ""}
      {!data.isFetching && vetObject === 'procedures' && data.procedures.length === 0 ? <p>No procedures found.</p> : ""}
      <Row className="mb-3">
        <Col xs={12} className="ps-0">
          <Paginator page={page} numPages={numPages} setPage={setPage} />
        </Col>
      </Row>
    </div>
  )
}

export default VetRequestSearch;
